import React from 'react';
import { FixedSizeList } from 'react-window';

// Custom Listbox za virtualni scroll
export const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemCount = Array.isArray(children) ? children.length : 0;

  return (
    <div ref={ref} {...other}>
      <FixedSizeList
        height={250}
        width="100%"
        itemSize={46}
        itemCount={itemCount}
        overscanCount={5}
      >
        {({ index, style }) => React.cloneElement(children[index], { style })}
      </FixedSizeList>
    </div>
  );
});
